import { sqliteTable, text, real, uniqueIndex } from "drizzle-orm/sqlite-core";

// ============================================================================
// stock_ledger — ยอดคงเหลือสินค้า (Running balance per item per warehouse)
// ============================================================================
export const stockLedger = sqliteTable("inventory_stock_ledger", {
  id: text("id").primaryKey(), // ULID
  companyId: text("company_id").notNull(),
  itemId: text("item_id").notNull(),
  warehouseId: text("warehouse_id").notNull(),
  currentQty: real("current_qty").notNull().default(0),
  currentValue: real("current_value").notNull().default(0), // total value at cost
  avgRate: real("avg_rate").notNull().default(0), // weighted average cost
  reorderLevel: real("reorder_level").default(0),
  createdAt: text("created_at"),
  createdBy: text("created_by"),
  updatedAt: text("updated_at").notNull(),
  updatedBy: text("updated_by"),
}, (table) => ({
  sl_item_wh_idx: uniqueIndex("sl_item_wh_idx").on(table.companyId, table.itemId, table.warehouseId),
}));

// Type exports
export type StockLedgerEntry = typeof stockLedger.$inferSelect;
export type NewStockLedgerEntry = typeof stockLedger.$inferInsert;
